import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { CycleMixtureRowComponent } from '../cycle-mixture-row/cycle-mixture-row.component';

@Component({
	selector: 'app-cycle-mixture',
	templateUrl: './cycle-mixture.component.html',
	styleUrls: ['./cycle-mixture.component.scss']
})
export class CycleMixtureComponent implements OnInit {
	@Input() public cycleMixureFormArray: FormArray;
	 @Output() onAddFormGroup: EventEmitter<any> = new EventEmitter<any>();
	// @Input() public incomeType;
	 @Output() onFormChange: EventEmitter<any> = new EventEmitter<any>();
	// @Input() public ph: string[];
	// @Input() public buttons: string[];
	@Input() public qID: string;
	@Input() public displayErrors: boolean;

	maxArrayLength = 4;
	//displayErrors

	constructor() { }

	ngOnInit() {


		let d = this.cycleMixureFormArray;
		console.debug("CycleMixtureComponent.ngOnInit()",this.cycleMixureFormArray);

	}

	emitChanges($event) {
		this.onFormChange.emit($event);
	}

	addrow() {
		// this.cycleMixureFormArray.push({});
		this.onAddFormGroup.emit();
		this.displayErrors = this.cycleMixureFormArray.invalid;

		if (this.cycleMixureFormArray.valid) {
			this.cycleMixureFormArray.push(CycleMixtureRowComponent.buildItem(''));
		}
	}

	simulateClick(event) {
		if (event.keyCode === 13) {
			event.currentTarget.click();
		}
	}

	//build form array 1
	static build(value: any) {
		let arr: FormGroup[] = [];

		if (value && value[0][0].answerValue) {
			value.forEach(element => {
				arr.push(CycleMixtureRowComponent.buildItem(element));
			});
		} else {
			arr.push(CycleMixtureRowComponent.buildItem(''));
		}

		return new FormArray(arr);
	}
}



// WEBPACK FOOTER //
// ./src/app/cycle-mixture/cycle-mixture.component.ts